/**
 * Créditos de una pregunta: los del turno (creditsConsumed, agent-runtime) más
 * los de su gráfica (chartCredits, chart-data, que se cobra aparte). null si
 * el turno no trae el dato (respuestas guardadas antes de que existiera).
 * chartPending: la gráfica todavía se está generando y su costo no está sumado.
 */
export const answerCredits = (answer) => {
    if (!answer || typeof answer.creditsConsumed !== 'number') {
        return null;
    }
    const chart = typeof answer.chartCredits === 'number' ? answer.chartCredits : 0;
    return {
        // Redondeo a 4 decimales: la suma en punto flotante deja ruido (3.0609000000000002).
        total: Math.round((answer.creditsConsumed + chart) * 10000) / 10000,
        chartPending: Boolean(answer.chartLoading)
    };
};

export const formatCredits = (value) => value.toLocaleString('es-MX', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
});

/** Texto al pie de la respuesta, o null si no hay dato. */
export const answerCreditsLabel = (answer) => {
    const credits = answerCredits(answer);
    if (!credits) {
        return null;
    }
    return `Créditos consumidos: ${formatCredits(credits.total)}`
        + (credits.chartPending ? ' (falta sumar la gráfica)' : '');
};
